import React, {Component} from 'react';
import marketStyle from '../css/markets.css';

import OddsCard from './oddsCard';

class WinDrawWin extends Component {
    render() {
        let store = this.props.store;
        let markets = this.props.markets;

        // TODO: this is a solution to have the team name on the market selection
        let selectedEvent = this.props.selectedEvent;
        markets[0].selection = selectedEvent.teamOne;
        markets[2].selection = selectedEvent.teamTwo;

        return (<div className={marketStyle.marketGroup}>
            <div className={marketStyle.scoreGroup}>
                <OddsCard store={store} market={markets[0]}/>
            </div>
            <div className={marketStyle.scoreGroup}>
                <OddsCard store={store} market={markets[1]}/>
            </div>
            <div className={marketStyle.scoreGroup}>
                <OddsCard store={store} market={markets[2]}/>
            </div>
        </div>);
    }
}

export default WinDrawWin;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/football/components/winDrawWin.js